import { reactive, toRefs, watch } from 'vue'

const KEYWORDS_STORAGE_KEY = 'material_search_keywords'
const VIDEO_KOLS_STORAGE_KEY = 'material_search_kols_normal'
const VIDEO_FILTERS_STORAGE_KEY = 'material_search_video_filters'

const videoSearchState = reactive({
  keyword: '',
  selectedKols: [],
  showAdvanced: false,
  startDate: '',
  endDate: ''
})

let initialized = false
let persistenceStarted = false

const getStorage = () => {
  if (typeof window === 'undefined') return null
  return window.sessionStorage
}

const readJson = (storage, key, fallback) => {
  try {
    const value = storage?.getItem(key)
    return value ? JSON.parse(value) : fallback
  } catch (error) {
    console.error(`Failed to parse session storage key "${key}"`, error)
    return fallback
  }
}

const initializeState = () => {
  if (initialized) return
  initialized = true

  const storage = getStorage()
  if (!storage) return

  const keywords = readJson(storage, KEYWORDS_STORAGE_KEY, {})
  const selectedKols = readJson(storage, VIDEO_KOLS_STORAGE_KEY, [])
  const filters = readJson(storage, VIDEO_FILTERS_STORAGE_KEY, {})

  videoSearchState.keyword = typeof keywords.video === 'string' ? keywords.video : ''
  videoSearchState.selectedKols = Array.isArray(selectedKols) ? selectedKols : []
  videoSearchState.showAdvanced = filters.showAdvanced === true
  videoSearchState.startDate = typeof filters.startDate === 'string' ? filters.startDate : ''
  videoSearchState.endDate = typeof filters.endDate === 'string' ? filters.endDate : ''
}

const startPersistence = () => {
  if (persistenceStarted) return
  persistenceStarted = true

  watch(() => videoSearchState.keyword, (keyword) => {
    const storage = getStorage()
    if (!storage) return

    const keywords = readJson(storage, KEYWORDS_STORAGE_KEY, {})
    storage.setItem(KEYWORDS_STORAGE_KEY, JSON.stringify({ ...keywords, video: keyword }))
  })

  watch(() => videoSearchState.selectedKols, (selectedKols) => {
    getStorage()?.setItem(VIDEO_KOLS_STORAGE_KEY, JSON.stringify(selectedKols))
  }, { deep: true })

  watch([
    () => videoSearchState.showAdvanced,
    () => videoSearchState.startDate,
    () => videoSearchState.endDate
  ], () => {
    getStorage()?.setItem(VIDEO_FILTERS_STORAGE_KEY, JSON.stringify({
      showAdvanced: videoSearchState.showAdvanced,
      startDate: videoSearchState.startDate,
      endDate: videoSearchState.endDate
    }))
  })
}

export const useMaterialSearchPersistence = () => {
  initializeState()
  startPersistence()
  return toRefs(videoSearchState)
}
